/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The bracket structure type for competition building blocks
 * @export
 */
export const CompetitionBracketType = {
    SINGLE_ELIMINATION: 'SINGLE_ELIMINATION',
    DOUBLE_ELIMINATION: 'DOUBLE_ELIMINATION',
    ROUND_ROBIN: 'ROUND_ROBIN',
    SWISS: 'SWISS',
    GROUPS_KNOCKOUT: 'GROUPS_KNOCKOUT'
} as const;
export type CompetitionBracketType = typeof CompetitionBracketType[keyof typeof CompetitionBracketType];


export function instanceOfCompetitionBracketType(value: any): boolean {
    for (const key in CompetitionBracketType) {
        if (Object.prototype.hasOwnProperty.call(CompetitionBracketType, key)) {
            if (CompetitionBracketType[key as keyof typeof CompetitionBracketType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionBracketTypeFromJSON(json: any): CompetitionBracketType {
    return CompetitionBracketTypeFromJSONTyped(json, false);
}

export function CompetitionBracketTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionBracketType {
    return json as CompetitionBracketType;
}

export function CompetitionBracketTypeToJSON(value?: CompetitionBracketType | null): any {
    return value as any;
}

export function CompetitionBracketTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionBracketType {
    return value as CompetitionBracketType;
}

